<template><slot /></template>
<script>
export default {
  name: "FormApiCapture",
  props: { formSlot: { type: Object, default: null } },
  watch: {
    formSlot: {
      handler(slot) {
        if (slot) this.$emit("update:api", slot);
      },
      immediate: true,
    },
  },
};
</script>
